import React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useEntityData } from '../../../../EntityContext';
import { sanitizeUrl } from '../../../../../../shared/utils/sanitizationUtils';
import { SidebarHeader } from '../SidebarHeader';
import { StyledLink } from '../LinkButton';

export default function SourceRefSection() {
    const { entityData } = useEntityData();

    const sourceUrl = entityData?.properties?.sourceUrl ? sanitizeUrl(entityData.properties.sourceUrl) : undefined;
    const sourceRef = entityData?.properties?.sourceRef ? sanitizeUrl(entityData.properties.sourceRef) : undefined;

    if (!sourceRef) return null;

    return (
        <>
            <SidebarHeader title="Source" />
            <Typography.Paragraph>
                {sourceUrl ? (
                    <StyledLink type="link" href={sourceUrl} target="_blank" rel="noreferrer">
                        <LinkOutlined />
                        {sourceRef}
                    </StyledLink>
                ) : (
                    <span>{sourceRef}</span>
                )}
            </Typography.Paragraph>
        </>
    );
}
